import { StyleSheet } from 'aphrodite';
import { brandPrimary } from '../../styles/colors';

export const styleSheet = StyleSheet.create({
	iconSize: {
		height: 20,
		width: 20,
		flexShrink: 0,
	},
	mobileMenu: {
		height: 42,
		marginLeft: -4,
		marginTop: 8,
		width: 42,
	},
	optionContent: {
		display: 'flex',
		alignItems: 'center',
		gap: 12,
	},
	optionStyles: {
		color: brandPrimary,
	},
	select: {
		background: 'none',
		border: 'none',
		marginLeft: -8,
	},
	userOptionsContainer: {},
});
